import api from "../../services/api";

const APIS = {
    GET_LOCATIONS: "/Location/phibro-locations"
};

export const getLocations = async (pageNumber = 1, pageSize = 1000, filterText = '') => {
    try {
        const res = await api.get(APIS.GET_LOCATIONS);

        const locations = Array.isArray(res.data) ? res.data : [];

        return {
            results: locations,
            totalCount: locations.length,
            success: true
        };
    } catch (error) {
        return { results: [], totalCount: 0, success: false };
    }
};
